import { Header } from '../../components/atoms';
import { HeadContent, Toast } from '../../components';
import { ForgotPassword } from './partials/ForgotPassword';

export default function ForgotPasswordTemplate() {
  return (
    <>
      <HeadContent
        metaTitle="GetNinjas | Orçamento de Profissionais Confiáveis no GetNinjas.com.br"
        slug=""
        metaDescription=""
        type="forgot-password:show"
        noindex
      />
      <Header.Simple />
      <ForgotPassword />
      <Toast />
    </>
  );
}
